import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { CareTeamRow } from "@/lib/database.types";

export function useCareTeam(patientId: string | undefined) {
  return useQuery<CareTeamRow[]>({
    queryKey: ["care_team", patientId],
    enabled: !!patientId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("care_team")
        .select("*, provider:providers(id,full_name,npi)")
        .eq("patient_id", patientId!)
        .is("removed_at", null)
        .order("assigned_at", { ascending: true });
      if (error) throw error;
      return (data as CareTeamRow[] | null) ?? [];
    },
  });
}
